 <div
  class="pill"
  [class.disabled]="disabled()"
  [formaAttention]="attention()"
  [formaAttentionLoop]="attentionLoop()"
  (attentionEnd)="attentionEnd.emit()">
      <ng-content select="[agentPrefix]" />
      <textarea
        #input
        class="field"
        rows="1"
        [value]="value()"
        [placeholder]="placeholder()"
        [disabled]="disabled()"
        [attr.aria-label]="ariaLabel()"
        (input)="onInput($event)"
        (keydown.enter)="onEnter($event)"></textarea>
      <ng-content select="[agentActions]" />
      <button
        type="button"
        class="send"
        [disabled]="!canSend()"
        [attr.aria-label]="sendLabel()"
        [title]="sendLabel()"
        (click)="emit()">
        <icon name="arrow-up" [size]="24" color="#ffffff" [ariaHidden]="true" />
      </button>
    </div>
